import { ibkApi } from '@ibk/shared-config';
import { VOUCHER_ONBOARDING_TYPE_WELCOME, } from '../types/voucherOnboarding';
const USER_ONBOARDING_URL = '/v1/benefits/user-onboarding';
const userOnboardingTagId = (type) => `benefits-user-onboarding-${type}`;
export const buildGetUserOnboardingQuery = ({ type = VOUCHER_ONBOARDING_TYPE_WELCOME }) => ({
    url: USER_ONBOARDING_URL,
    method: 'GET',
    params: { type },
});
export const transformGetUserOnboardingResponse = (response) => response.result ?? [];
export const buildCompleteUserOnboardingMutation = ({ type }) => ({
    url: USER_ONBOARDING_URL,
    method: 'POST',
    body: { type },
});
export const userOnboardingApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        getBenefitsUserOnboarding: build.query({
            query: buildGetUserOnboardingQuery,
            transformResponse: transformGetUserOnboardingResponse,
            providesTags: (_result, _error, { type = VOUCHER_ONBOARDING_TYPE_WELCOME }) => [
                { type: 'Emissor', id: userOnboardingTagId(type) },
            ],
        }),
        completeBenefitsUserOnboarding: build.mutation({
            query: buildCompleteUserOnboardingMutation,
            invalidatesTags: (_result, _error, { type }) => [{ type: 'Emissor', id: userOnboardingTagId(type) }],
        }),
    }),
    overrideExisting: false,
});
export const { useGetBenefitsUserOnboardingQuery, useCompleteBenefitsUserOnboardingMutation } = userOnboardingApi;
